import React, { useState, useEffect, useRef, useCallback } from "react";
import { Container, Carousel } from "react-bootstrap";

import ItemSlider from "./ItemSlider";

const Slider = ({ elements }) => {
  const [index, setIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);
  const AUTO_PLAY_INTERVAL = 3500;

  const handleSelect = (selectedIndex, e) => {
    let beforeSlide = elements[index];
    let afterSlide = elements[selectedIndex];
    let video;

    if (beforeSlide.type_rsc === 1) {
      if (!beforeSlide.resource.indexOf("youtube")) {
        video = document.getElementById(`${index}${beforeSlide.resource}`);
        if (video.paused) {
        } else {
          video.pause();
        }
      } else {
        setIsPlaying(false);
      }
    }

    if (afterSlide.type_rsc === 1) {
      if (!beforeSlide.resource.indexOf("youtube")) {
        video = document.getElementById(
          `${selectedIndex}${afterSlide.resource}`
        );
        if (video.paused) {
          video.play();
        }
      } else {
        setIsPlaying(true);
      }
    }
    setIndex(selectedIndex);
  };

  // Función para avanzar al siguiente slide
  const nextSlide = useCallback(() => {
    if (elements && elements.length > 0) {
      setIndex((prevIndex) => (prevIndex + 1) % elements.length);
    }
  }, [elements]);

  // Efecto para manejar el auto-play
  useEffect(() => {
    if (elements && elements.length > 1 && !isPaused) {
      intervalRef.current = setInterval(() => {
        nextSlide();
      }, AUTO_PLAY_INTERVAL);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, elements, nextSlide]);

  // Manejar pausa cuando el mouse entra
  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  // Reanudar cuando el mouse sale
  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <>
      {elements && elements?.length > 0 && (
        <Container fluid className="container-fluid px-0">
          <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Carousel
              data-testid="carousel"
              controls={elements?.length > 1 ? true : false}
              interval={null}
              activeIndex={index}
              onSelect={handleSelect}
              indicators={elements?.length > 1 ? true : false}
            >
              {elements?.map((item, i) => (
                <Carousel.Item key={i} className="container-slider">
                  <ItemSlider item={item} i={i} isPlaying={isPlaying} />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </Container>
      )}
    </>
  );
};

export default Slider;
